import { render, staticRenderFns } from "./UPEICalorimetryPreLabPt1.vue?vue&type=template&id=5dbc62c2&"
import script from "./UPEICalorimetryPreLabPt1.vue?vue&type=script&lang=js&"
export * from "./UPEICalorimetryPreLabPt1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
